import { useAppContext } from '../../../AppContext';
import { File, FormItem } from '@vkontakte/vkui';
import { Icon24Camera } from '@vkontakte/icons';
import React, { useState } from 'react';
import { getResponseFromError } from '../../../helpers/helpers';

export const ImageUploadComponent = ({eventId, error, setError, value, setValue, label, maxSize, errorMaxCount, errorTextMaxSize, errorTextType, buttonLabel}) => {
  const context = useAppContext();
  const availableTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const [filesLoading, setFilesLoading] = useState(0);

  const onChange = (files) => {
    if (files.filter((file) => file.size > maxSize).length > 0) {
      setError(context.lang().replace(errorTextMaxSize, {'size': Math.ceil(context.store.maxFileSize / 1024 / 1024)}));
    } else if (files.filter((file) => availableTypes.indexOf(file.type) === -1).length > 0) {
      setError(errorTextType);
    } else if ((value.length + files.length) > 10) {
      setError(errorMaxCount);
    } else {
      setError('');
      files.forEach((file) => {
        setFilesLoading((prevState) => prevState + 1);
        context.httpClient()
          .uploadItemImageV3(eventId, file)
          .then((response) => {
            setValue((prevState) => [...prevState, response.data])
            setFilesLoading((prevState) => prevState - 1);
          })
          .catch((error) => {
            setFilesLoading((prevState) => prevState - 1);

            const response = getResponseFromError(error);
            if (!response) {
              context.showError(error);
              return;
            }
            setError(response.message || response.image || '');
          });
      });
    }
  }

  return (<FormItem
      top={label}
      status={error.length > 0 ? 'error' : ''}
      bottom={error}
    >
      <File
        onChange={(event) => onChange(Array.from(event.target.files))}
        stretched={true}
        align={'center'}
        before={filesLoading > 0 ? <Icon24Camera /> : null}
        mode={filesLoading > 0 ? 'primary' : 'outline'}
        size={'l'}
        accept={availableTypes.join(', ')}
        loading={filesLoading > 0}
        disabled={filesLoading > 0 || value.length >= 10}
        multiple={false}
      >
        {
          filesLoading > 0 ? '' : buttonLabel
        }
      </File>
    </FormItem>);
}
